import { Component } from "react";
import { AlertTriangle } from "lucide-react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info);
  }
  reset = () => this.setState({ error: null });
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="p-6">
        <div className="bms-card p-6 max-w-2xl mx-auto">
          <div className="flex items-start gap-3">
            <div className="h-10 w-10 rounded-xl bg-rose-50 text-rose-600 grid place-items-center">
              <AlertTriangle className="h-5 w-5" />
            </div>
            <div className="flex-1">
              <h3 className="font-display text-lg font-semibold text-slate-900">
                Something went wrong on this page
              </h3>
              <p className="text-sm text-slate-500 mt-1">
                {String(this.state.error?.message || this.state.error)}
              </p>
              <button
                onClick={this.reset}
                className="mt-4 inline-flex items-center px-4 py-2 rounded-md bg-navy-800 text-white text-sm hover:bg-navy-900"
                data-testid="error-boundary-retry"
              >
                Try again
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
